
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { usePaymentDropdowns } from "../../hooks/usePaymentDropdowns";
import { Link, useLocation } from "react-router-dom";
import { Row, Col, Card, Divider, Table, Button, Input, notification, AutoComplete, Modal, Select, Avatar, Typography, TableColumnsType, Checkbox, DatePicker, Spin, Drawer, Badge, Tooltip, message, Dropdown, Menu } from "antd";
import axios from "axios";
import { baseUrl, socketUrl } from "../../config";
import { DeleteOutlined, FilterOutlined, SendOutlined, FileExcelOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined, EyeOutlined, UserOutlined, BankOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, RiseOutlined, CalendarOutlined, DownloadOutlined, FileTextOutlined, PictureOutlined, PlusCircleOutlined } from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import * as XLSX from 'xlsx';
import Invoice from "../../components/Invoice";
import PaymentsEditForm from './EditUserPayment';
import BankReconcile from './BankReconcile';
import ViewPayments from './ViewPayments';

const { confirm } = Modal;
const { Search } = Input;
const { Option } = Select;
const { Title } = Typography;
const { MonthPicker, RangePicker } = DatePicker;

function PaymentsList({ toggleEditDrawer }) {
  const { bankAccounts, specialOccasions } = usePaymentDropdowns();
  const location = useLocation();
  // Get current page from URL, or default to 1
  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get('page')) || 1;
  const limitQuery = parseInt(queryParams.get('limit')) || parseInt(localStorage.getItem('payment_list_limit')) || 20;
  const [paymentList, setPaymentList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(currentPageQuery);
  const [limit, setLimit] = useState(limitQuery);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [staffList, setStaffList] = useState([]);
  const [sendPaynmentNotice, setSendPaynmentNotice] = useState(null);
  const [buttonText, setButtonText] = useState("Send");
  const [loading, setLoading] = useState(false);
  const [optionSuggestion, setOptionSuggestion] = useState([]);
  const [currentPaymentId, setCurrentPaymentId] = useState(null);
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [todayTotal, setTodayTotal] = useState(0);
  const [dashboardStats, setDashboardStats] = useState({
    todayVerified: 0,
    todayPending: 0,
    todayFailed: 0,
    todayTotal: 0,
    todayEntryCount: 0,
    messagesSent: 0,
    pendingReceipts: 0
  });
  const [duplicateUTRs, setDuplicateUTRs] = useState([]);
  const [duplicateAmountPhone, setDuplicateAmountPhone] = useState([]);
  const [filteredTotal, setFilteredTotal] = useState(0);
  const [reconcileVisible, setReconcileVisible] = useState(false);
  const [queueCount, setQueueCount] = useState(0);
  const [stagingLoading, setStagingLoading] = useState(false);
  const [viewDrawerVisible, setViewDrawerVisible] = useState(false);
  const [viewPaymentId, setViewPaymentId] = useState(null);

  // Bulk message functionality states
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [bulkSendLoading, setBulkSendLoading] = useState(false);
  const [bulkSendProgress, setBulkSendProgress] = useState({ current: 0, total: 0 });
  const [currentBulkIndex, setCurrentBulkIndex] = useState(0);
  const [bulkPaymentIds, setBulkPaymentIds] = useState([]);

  // Bulk Verify mode states
  const [bulkVerifyMode, setBulkVerifyMode] = useState(false);
  const [selectedVerifyPayments, setSelectedVerifyPayments] = useState([]);
  const [bulkVerifyLoading, setBulkVerifyLoading] = useState(false);

  // Filter states — restore from localStorage if available
  const txnDateRange = queryParams.get('txn_date_range') ? queryParams.get('txn_date_range').split(',') : [];
  const entryDateRange = queryParams.get('entry_date_range') ? queryParams.get('entry_date_range').split(',') : [];
  const monthRange = queryParams.get('month_range') ? queryParams.get('month_range').split(',') : [];

  const savedFilters = (() => {
    try { return JSON.parse(sessionStorage.getItem('payment_list_filters')) || null; } catch { return null; }
  })();

  const [filters, setFilters] = useState(savedFilters || {
    name: queryParams.get('name') || '',
    email: queryParams.get('email') || '',
    phone: queryParams.get('phone') || '',
    amount: queryParams.get('amount') || '',
    receipt_no: queryParams.get('receipt_no') || '',
    e_reciept_no: queryParams.get('e_reciept_no') || '',
    e_reciept_date: queryParams.get('e_reciept_date') || '',
    utr_number: queryParams.get('utr_number') || '',
    bank_account: queryParams.get('bank_account') || '',
    special_occassion_category: queryParams.get('special_occassion_category') || '',
    relation_hn: queryParams.get('relation_hn') || '',
    transaction_date: queryParams.get('transaction_date') || '',
    pyament_mode_type: queryParams.get('pyament_mode_type') || '',
    payment_entry_date: queryParams.get('payment_entry_date') || '',
    payment_virify: queryParams.get('payment_virify') || '',
    is_send: queryParams.get('is_send') || '',
    staff_id: queryParams.get('staff_id') || '',
    month_range: monthRange,
    amountMin: queryParams.get('amountMin') || '',
    amountMax: queryParams.get('amountMax') || '',
    min_monthly_amount: queryParams.get('min_monthly_amount') || '',
    max_monthly_amount: queryParams.get('max_monthly_amount') || '',
    payment_commitment: queryParams.get('payment_commitment') || '',
    txn_date_range: txnDateRange,
    entry_date_range: entryDateRange,
    receipt_queue: queryParams.get('receipt_queue') || '',
  });

  // Bulk message functions
  const handleSelectPayment = (paymentId, checked) => {
    if (checked) {
      setSelectedPayments(prev => [...prev, paymentId]);
    } else {
      setSelectedPayments(prev => prev.filter(id => id !== paymentId));
    }
  };

  const eligiblePayments = useMemo(() =>
    paymentList.filter(payment =>
      payment.is_payment_check === "checked" &&
      payment.payment_virify === "verified"
    ), [paymentList]);

  // Payments eligible for bulk verify: must be checked but still pending
  const verifyEligiblePayments = useMemo(() =>
    paymentList.filter(p =>
      p.is_payment_check === 'checked' &&
      p.payment_virify === 'pending'
    ), [paymentList]);

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedPayments(eligiblePayments.map(payment => payment.payment_id));
    } else {
      setSelectedPayments([]);
    }
  };

  const getEligiblePayments = () => eligiblePayments;

  // Bulk Verify mode handlers
  const handleVerifySelectPayment = (paymentId, checked) => {
    if (checked) {
      setSelectedVerifyPayments(prev => [...prev, paymentId]);
    } else {
      setSelectedVerifyPayments(prev => prev.filter(id => id !== paymentId));
    }
  };

  const handleVerifySelectAll = (checked) => {
    if (checked) {
      setSelectedVerifyPayments(verifyEligiblePayments.map(p => p.payment_id));
    } else {
      setSelectedVerifyPayments([]);
    }
  };

  const handleBulkVerify = async () => {
    if (!selectedVerifyPayments.length) {
      notification.warning({ message: 'Select at least one payment to verify', placement: 'topRight' });
      return;
    }
    Modal.confirm({
      title: `Verify ${selectedVerifyPayments.length} Payment(s)?`,
      icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
      content: (
        <div>
          <p>This will mark <strong>{selectedVerifyPayments.length}</strong> payment(s) as <strong style={{ color: '#52c41a' }}>Verified</strong>.</p>
          <p style={{ color: '#888', fontSize: '12px' }}>Only "Checked + Pending" payments are included. This action cannot be undone.</p>
        </div>
      ),
      okText: `Yes, Verify ${selectedVerifyPayments.length}`,
      okButtonProps: { style: { backgroundColor: '#52c41a', borderColor: '#52c41a' } },
      cancelText: 'Cancel',
      onOk: async () => {
        setBulkVerifyLoading(true);
        try {
          const res = await axios.post(
            `${baseUrl}/payments/reconcile-confirm`,
            { payment_ids: selectedVerifyPayments, also_verify: true },
            { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
          );
          if (res.data.status) {
            notification.success({
              message: 'Bulk Verify Complete',
              description: `${selectedVerifyPayments.length} payment(s) verified successfully.`,
              placement: 'topRight',
              duration: 3
            });
            setSelectedVerifyPayments([]);
            setBulkVerifyMode(false);
            getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
          } else {
            notification.error({ message: 'Bulk verify failed', description: res.data.message, placement: 'topRight' });
          }
        } catch (e) {
          notification.error({ message: 'Bulk verify failed', placement: 'topRight' });
        } finally {
          setBulkVerifyLoading(false);
        }
      }
    });
  };

  const handleBulkSendReceipts = async () => {
    if (selectedPayments.length === 0) {
      notification.warning({
        message: 'Warning',
        description: 'Please select at least one payment to send receipts.',
        placement: 'topRight'
      });
      return;
    }

    Modal.confirm({
      title: 'Confirm Bulk Send',
      content: (
        <div>
          <p>Are you sure you want to send WhatsApp receipts to {selectedPayments.length} selected payments?</p>
          <p style={{ color: '#666', fontSize: '12px' }}>
            Note: Each receipt will be processed individually using your existing WhatsApp system.
          </p>
        </div>
      ),
      okText: 'Yes, Send All',
      cancelText: 'Cancel',
      onOk: async () => {
        setBulkSendLoading(true);
        setBulkPaymentIds([...selectedPayments]);
        setCurrentBulkIndex(0);
        setBulkSendProgress({ current: 0, total: selectedPayments.length });
        
        // Start with the first payment
        if (selectedPayments.length > 0) {
          setSendPaynmentNotice(selectedPayments[0]);
        }
      }
    });
  };

  // ── Receipt Queue handlers ──────────────────────────────────────────────────

  const fetchQueueCount = async () => {
    try {
      const res = await axios.get(`${baseUrl}/payments/receipt-queue-count`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
      if (res.data.status) setQueueCount(res.data.count);
    } catch (e) { /* silent */ }
  };

  // Stage a single payment
  const handleStageReceipt = async (paymentId) => {
    try {
      const res = await axios.post(
        `${baseUrl}/payments/stage-receipts`,
        { payment_ids: [paymentId] },
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );
      if (res.data.status && res.data.staged_count > 0) {
        notification.success({ message: 'Added to receipt queue', placement: 'topRight', duration: 1.5 });
        setQueueCount(c => c + 1);
        getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
      } else if (res.data.status && res.data.staged_count === 0) {
        notification.warning({ message: 'Payment not eligible to stage (must be Checked & Verified)', placement: 'topRight', duration: 3 });
      }
    } catch (e) {
      notification.error({ message: 'Failed to stage receipt', placement: 'topRight' });
    }
  };

  // Remove a single payment from queue
  const handleUnstageReceipt = async (paymentId) => {
    try {
      const res = await axios.post(
        `${baseUrl}/payments/unstage-receipts`,
        { payment_ids: [paymentId] },
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );
      if (res.data.status) {
        notification.info({ message: 'Removed from receipt queue', placement: 'topRight', duration: 1.5 });
        setQueueCount(c => Math.max(0, c - 1));
        getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
      }
    } catch (e) {
      notification.error({ message: 'Failed to remove from queue', placement: 'topRight' });
    }
  };

  // Stage all selected payments at once
  const handleStageSelected = async () => {
    if (!selectedPayments.length) {
      notification.warning({ message: 'Select at least one payment first', placement: 'topRight' });
      return;
    }
    setStagingLoading(true);
    try {
      const res = await axios.post(
        `${baseUrl}/payments/stage-receipts`,
        { payment_ids: selectedPayments },
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );
      if (res.data.status) {
        notification.success({
          message: `${res.data.staged_count} payment(s) added to receipt queue`,
          placement: 'topRight', duration: 2
        });
        setSelectedPayments([]);
        fetchQueueCount();
        getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
      }
    } catch (e) {
      notification.error({ message: 'Staging failed', placement: 'topRight' });
    } finally {
      setStagingLoading(false);
    }
  };

  // Show only queued payments (filter shortcut)
  const handleViewQueue = () => {
    handleFilterChange('receipt_queue', 'queued', true);
  };

  // Today quick filter
  const handleTodayFilter = () => {
    const today = moment().format('DD-MM-YYYY');
    const newFilters = { ...filters, payment_entry_date: today, entry_date_range: [] };
    setFilters(newFilters);
    sessionStorage.setItem('payment_list_filters', JSON.stringify(newFilters));
    getPaymentList(1, limit, sortField, sortOrder, search, newFilters);
  };

  // This Week quick filter
  const handleThisWeekFilter = () => {
    const start = moment().startOf('isoWeek').format('DD-MM-YYYY');
    const end = moment().endOf('isoWeek').format('DD-MM-YYYY');
    const newFilters = { ...filters, entry_date_range: [start, end], payment_entry_date: '' };
    setFilters(newFilters);
    sessionStorage.setItem('payment_list_filters', JSON.stringify(newFilters));
    getPaymentList(1, limit, sortField, sortOrder, search, newFilters);
  };

  // This Month quick filter
  const handleThisMonthFilter = () => {
    const start = moment().startOf('month').format('DD-MM-YYYY');
    const end = moment().endOf('month').format('DD-MM-YYYY');
    const newFilters = { ...filters, entry_date_range: [start, end], payment_entry_date: '' };
    setFilters(newFilters);
    sessionStorage.setItem('payment_list_filters', JSON.stringify(newFilters));
    getPaymentList(1, limit, sortField, sortOrder, search, newFilters);
  };

  // Copy text to clipboard
  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      message.success(`${label} copied`, 1.5);
    }).catch(() => {
      message.error('Copy failed');
    });
  };

  // Send all queued payments (uses existing bulk send mechanism)
  const handleSendAllQueued = () => {
    const queued = paymentList.filter(p => p.receipt_queue === 'queued');
    if (!queued.length) {
      notification.warning({ message: 'No queued receipts on this page. Use "View Queue" filter first.', placement: 'topRight' });
      return;
    }
    const ids = queued.map(p => p.payment_id);
    Modal.confirm({
      title: `Send ${ids.length} Queued Receipts`,
      content: `This will send WhatsApp receipts to ${ids.length} members. Continue?`,
      okText: 'Send All',
      okButtonProps: { style: { backgroundColor: '#52c41a', borderColor: '#52c41a' } },
      onOk: async () => {
        setBulkSendLoading(true);
        setBulkPaymentIds(ids);
        setCurrentBulkIndex(0);
        setBulkSendProgress({ current: 0, total: ids.length });
        setSendPaynmentNotice(ids[0]);
      }
    });
  };

  // ── End Receipt Queue handlers ──────────────────────────────────────────────

  // Mark a payment's receipt_queue as 'sent' after WhatsApp send
  const markReceiptQueueSent = async (paymentId) => {
    try {
      await axios.post(
        `${baseUrl}/payments/mark-receipt-sent`,
        { payment_id: paymentId },
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );
      setQueueCount(c => Math.max(0, c - 1));
    } catch (e) { /* silent — receipt was sent even if this fails */ }
  };

  // Enhanced handleResendBtn to handle both bulk and individual processing
  const handleResendBtn = () => {
    const justSentId = bulkSendLoading ? bulkPaymentIds[currentBulkIndex] : sendPaynmentNotice;
    // Mark the just-sent payment as 'sent' in queue
    if (justSentId) markReceiptQueueSent(justSentId);

    const nextIndex = currentBulkIndex + 1;

    if (bulkSendLoading && nextIndex < bulkPaymentIds.length) {
      // Continue with next payment in bulk
      setCurrentBulkIndex(nextIndex);
      setBulkSendProgress({ current: nextIndex, total: bulkPaymentIds.length });
      setSendPaynmentNotice(bulkPaymentIds[nextIndex]);
    } else if (bulkSendLoading && nextIndex >= bulkPaymentIds.length) {
      // Bulk sending completed
      setBulkSendLoading(false);
      setBulkPaymentIds([]);
      setCurrentBulkIndex(0);
      setBulkSendProgress({ current: 0, total: 0 });
      setSelectedPayments([]);
      setSendPaynmentNotice('');

      getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);

      notification.success({
        message: 'Bulk Send Complete',
        description: `All ${bulkPaymentIds.length} receipts have been sent successfully!`,
        placement: 'topRight',
        duration: 4
      });
    } else {
      // Regular single send
      setSendPaynmentNotice('');
      setLoading(false);
      getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
    }
  };

  // Edit payment handlers
  const handleEditSuccess = () => {
    // Refresh payment list
    getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
    
    // Show success notification
    notification.success({
      message: 'Success',
      description: 'Payment updated successfully!',
      placement: 'topRight',
      duration: 2
    });
    
    // Close drawer
    closeEditDrawer();
  };

 const handleSendPaymentNotification = (payment_id) => {
    Modal.confirm({
      title: 'Are you sure you want to send receipt on whatsapp ?',
      onOk: async () => {
        setLoading(true);
        setSendPaynmentNotice(payment_id);
      }
    });
  }

  const showEditDrawer = (id) => {
  setCurrentPaymentId(id);
  setEditDrawerVisible(true);
};

const closeEditDrawer = () => {
  setEditDrawerVisible(false);
  setCurrentPaymentId(null);
};

  const createStyledTitle = (text) => (
    <span style={{ fontSize: '13px', color: '#7a0000', fontWeight: 700 }}>{text}</span>
  );

  // Table columns definition
  const columns = useMemo(() => [
    // Bulk selection checkbox column (switches between receipt-send mode and bulk-verify mode)
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {bulkVerifyMode ? (
            <Checkbox
              checked={verifyEligiblePayments.length > 0 && selectedVerifyPayments.length === verifyEligiblePayments.length}
              indeterminate={selectedVerifyPayments.length > 0 && selectedVerifyPayments.length < verifyEligiblePayments.length}
              onChange={(e) => handleVerifySelectAll(e.target.checked)}
              title="Select all Checked+Pending"
            />
          ) : (
            <Checkbox
              checked={eligiblePayments.length > 0 && selectedPayments.length === eligiblePayments.length}
              indeterminate={selectedPayments.length > 0 && selectedPayments.length < eligiblePayments.length}
              onChange={(e) => handleSelectAll(e.target.checked)}
            />
          )}
        </div>
      ),
      key: "select",
      fixed: 'left',
      width: 55,
      align: 'center',
      render: (_, record) => {
        if (bulkVerifyMode) {
          const isVerifyEligible = record.is_payment_check === 'checked' && record.is_virify === 'pending';
          return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Tooltip title={!isVerifyEligible ? 'Only Checked + Pending payments can be bulk verified' : ''}>
                <Checkbox
                  checked={selectedVerifyPayments.includes(record.payment_id)}
                  onChange={(e) => handleVerifySelectPayment(record.payment_id, e.target.checked)}
                  disabled={!isVerifyEligible}
                />
              </Tooltip>
            </div>
          );
        }
        const isEligible = record.is_payment_check === "checked" &&
                          record.is_virify === "verified";
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Checkbox
              checked={selectedPayments.includes(record.payment_id)}
              onChange={(e) => handleSelectPayment(record.payment_id, e.target.checked)}
              disabled={!isEligible}
            />
          </div>
        );
      }
    },

    {
      title: createStyledTitle("S.No"),
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
          <span style={{ fontWeight: 600, fontSize: 12, color: '#7a0000' }}>{text}</span>
          <span style={{
            display: 'inline-block', width: 8, height: 8, borderRadius: '50%',
            background: record.payment_status === 'Verified' ? '#52c41a' : record.payment_status === 'Failed' ? '#ff4d4f' : '#faad14',
            boxShadow: record.payment_status === 'Verified' ? '0 0 4px #52c41a' : record.payment_status === 'Failed' ? '0 0 4px #ff4d4f' : '0 0 4px #faad14',
          }} />
        </div>
      ),
    },
    {
      title: createStyledTitle("Name"),
      dataIndex: "name",
      key: "name",
      fixed: 'left',
      // sorter: true,
      width: 150,
    },
    {
      title: createStyledTitle("Receipt no."),
      dataIndex: "receipt_no",
      key: "receipt_no",
      width: 110,
    },
    {
      title: createStyledTitle("Amount"),
      dataIndex: "amount",
      key: "amount",
      width: 120,
    },
    {
      title: createStyledTitle("Tnx (UTR/ID)"),
      dataIndex: "utr_number",
      key: "utr_number",
      width: 150,
    },
    {
      title: createStyledTitle("Tnx Date"),
      dataIndex: "transaction_date",
      key: "transaction_date",
      width: 110,
    },
    {
      title: createStyledTitle("Start Month"),
      dataIndex: "start_month",
      key: "start_month",
      width: 120,
    },
    {
      title: createStyledTitle("End Month"),
      dataIndex: "end_month",
      key: "end_month",
      width: 110,
    },
    {
      title: createStyledTitle("Duration"),
      dataIndex: "duration_type",
      key: "duration_type",
      width: 88,
    },
    {
      title: createStyledTitle("Account"),
      key: "bank_account",
      width: 150,
      render: (_, record) => (
        <div>
          <div>{record.bank_account}</div>
          {record.special_occassion_category && (
            <div style={{ fontSize: '11px', color: '#888', marginTop: 2 }}>
              {record.special_occassion_category}
            </div>
          )}
        </div>
      ),
    },
    {
      title: createStyledTitle("Entry Date"),
      dataIndex: "payment_entry_date",
      key: "payment_entry_date",
      width: 110,
    },
    {
      title: createStyledTitle("C/R-Recipt/Date"),
      key: "e_reciept_no",
      width: 130,
      render: (_, record) => (
        <div>
          <div>{record.e_reciept_no || '-'}</div>
          {record.e_reciept_date && (
            <div style={{ fontSize: '11px', color: '#888', marginTop: 2 }}>
              {record.e_reciept_date}
            </div>
          )}
        </div>
      ),
    },
    {
      title: createStyledTitle("Created By"),
      key: "firstName",
      dataIndex: "firstName",
      width: 120,
    },
    {
      title: createStyledTitle("Updated By"),
      key: "firstNameUpdate",
      dataIndex: "firstNameUpdate",
      width: 120,
    },


    {
      title: createStyledTitle("Poster"),
      key: "is_send",
      dataIndex: "is_send",
      width: 90,
      fixed: 'right',
      render: (text, record) => {
        const menuItems = (
          <Menu>
            <Menu.Item
              key="send"
              icon={<SendOutlined />}
              onClick={() => setSendPaynmentMsg(record.payment_id, record.user_id)}
            >
              {record.is_send_msg === 0 ? 'Send' : 'ReSend'}
            </Menu.Item>
            <Menu.Item
              key="download"
              icon={<DownloadOutlined />}
              onClick={() => downloadPoster(record.payment_id, record.receipt_no)}
            >
              Download Poster
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuItems} trigger={['click']} placement="bottomRight">
            <Button
              size="small"
              type="primary"
              style={{
                backgroundColor: record.is_send_msg === 0 ? '#faad14' : '#13c2c2',
                borderColor: record.is_send_msg === 0 ? '#faad14' : '#13c2c2',
                fontSize: '11px',
              }}
            >
              {record.is_send_msg === 0 ? 'Send' : 'ReSend'} ▾
            </Button>
          </Dropdown>
        );
      },
    },

    ...(hasPermission('/payments', 'editPermission')
    ? [
      {
        title: createStyledTitle("Check Pay"),
        key: "is_payment_check",
        dataIndex: "is_payment_check",
        fixed: 'right',
        width: 50,  // Adjust width based on content
        render: (text, record) => (
          <div className="button-container">
            {(record.is_payment_check === 'unchecked' || record.is_payment_check === '' || record.is_payment_check === null) && (
              <Button
                type="primary"
                style={{ backgroundColor: '#fa8c16', color: '#fff', borderColor: '#fa8c16', fontSize: "12px", height: "35px", padding: "0 8px", lineHeight: "35px" }}
                onClick={() => handleCheckPayment(record.payment_id, 'checked')}
              >
                Unchecked
              </Button>
            )}
            {record.is_payment_check === 'checked' && (
              <Button
                type="primary"
                style={{ backgroundColor: '#52c41a', color: '#fff', borderColor: '#52c41a', fontSize: "12px", height: "35px", padding: "0 8px", lineHeight: "35px" }}
                onClick={() => handleCheckPayment(record.payment_id, 'unchecked')}
              >
                Checked
              </Button>
            )}
          </div>
        ),
      },
      ]
    : []),

    ...(hasPermission('/payments', 'editPermission')
    ? [
      {
        title: createStyledTitle("Payment"),
        key: "payment_virify",
        dataIndex: "payment_virify",
        fixed: 'right',
        width: 110,
      },
      ]
    : []),

   

    {
      title: createStyledTitle("Receipt"),
      key: "receipt_queue",
      dataIndex: "receipt_queue",
      fixed: 'right',
      width: 80,
      onHeaderCell: () => ({
        style: { padding: "2px 6px", backgroundColor: "#f5f5f5", textAlign: "center" }
      }),
      render: (receipt_queue, record) => {
        const isEligible = record.is_payment_check === "checked" &&
                           record.is_virify === "verified";

        // Stage 3: already sent
        if (receipt_queue === 'sent') {
          return (
            <Button
              size="small"
              style={{ backgroundColor: '#13c2c2', borderColor: '#13c2c2', color: '#fff', fontSize: "12px", height: "30px" }}
              onClick={() => handleSendPaymentNotification(record.payment_id)}
            >
              Re-Send
            </Button>
          );
        }

        // Stage 2: queued — click to remove from queue
        if (receipt_queue === 'queued') {
          return (
            <Button
              size="small"
              style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', color: '#fff', fontSize: "12px", height: "30px" }}
              onClick={() => handleUnstageReceipt(record.payment_id)}
              title="Click to remove from queue"
            >
              Queued ✓
            </Button>
          );
        }

        // Stage 1: eligible → Stage button; not eligible → disabled
        if (isEligible) {
          return (
            <Button
              size="small"
              style={{ backgroundColor: '#faad14', borderColor: '#faad14', color: '#fff', fontSize: "12px", height: "30px" }}
              onClick={() => handleStageReceipt(record.payment_id)}
            >
              Stage
            </Button>
          );
        }

        return (
          <Button
            size="small"
            disabled
            style={{ fontSize: "12px", height: "30px" }}
          >
            Stage
          </Button>
        );
      }
    },

    {
      title: createStyledTitle("Action"),
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 160,
      render: (text, record) => (
        <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
          {hasPermission('/payments', 'editPermission') && (
            <button onClick={() => handleEdit(record.payment_id)} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#7a0000', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
              <EditOutlined style={{ fontSize: 11 }} /> Edit
            </button>
          )}
          {hasPermission('/payments', 'readPermission') && (
            <button onClick={() => handleView(record.payment_id)} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#1677ff', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
              <EyeOutlined style={{ fontSize: 11 }} /> View
            </button>
          )}
          {hasPermission('/payments', 'deletePermission') && (
            <button onClick={() => showDeleteConfirm(record.payment_id)} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
              <DeleteOutlined style={{ fontSize: 11 }} /> Remove
            </button>
          )}
        </div>
      )
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [selectedPayments, eligiblePayments, selectedVerifyPayments, verifyEligiblePayments, bulkVerifyMode, duplicateUTRs, duplicateAmountPhone]);


  useEffect(() => {
    getStaffList();
    getTodayTotal(null);
    fetchQueueCount();
    if (localStorage.getItem('payment_added') === 'true') {
      localStorage.removeItem('payment_added');
    }
    getPaymentList(currentPage, limit, null, null, search, filters);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

 const labelStyle = {
  fontSize: '13px',
  color: '#000000ff', 
  display: 'block',
  marginBottom: '4px',
  fontWeight: 500,
  height: '16px',
  lineHeight: '16px'
};
  

  async function getStaffList() {
    try {
      const response = await axios.get(`${baseUrl}/staff/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setStaffList(response.data.result);
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRighft'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  async function getTodayTotal(accountId = null) {
    try {
      const today = moment().format('DD-MM-YYYY');
      const accountParam = accountId ? `&bank_account=${accountId}` : '';
      const response = await axios.get(`${baseUrl}/payments/list?page=1&limit=all${accountParam}&payment_entry_date=${today}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const payments = response.data.result;

        // Calculate total amount
        const total = payments.reduce((sum, payment) => {
          return sum + (parseFloat(payment.amount) || 0);
        }, 0);

        // Calculate status counts
        const verified = payments.filter(p => p.payment_virify === 'verified').length;
        const pending = payments.filter(p => p.payment_virify === 'pending').length;
        const failed = payments.filter(p => p.payment_virify === 'failed').length;

        // Calculate messages sent (is_send = 'sent')
        const messagesSent = payments.filter(p => p.is_send === 'sent').length;

        // Pending receipts = verified but not sent
        const pendingReceipts = payments.filter(p =>
          p.payment_virify === 'verified' &&
          p.is_send !== 'sent' &&
          p.is_payment_check === 'checked'
        ).length;

        setTodayTotal(total);
        setDashboardStats({
          todayVerified: verified,
          todayPending: pending,
          todayFailed: failed,
          todayTotal: total,
          todayEntryCount: payments.length,
          messagesSent: messagesSent,
          pendingReceipts: pendingReceipts
        });
      }
    } catch (error) {
      console.error("Error fetching today's total:", error);
    }
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  async function getPaymentList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try { 

      setCurrentPage(page);
      setLimit(limit);
      localStorage.setItem('payment_list_limit', limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/payments/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const payments = response.data.result;
        setPaymentList(payments);
        setFilteredTotal(response.data.totalAmount || 0);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });

        // Detect duplicate UTR numbers
        const utrMap = {};
        const duplicates = [];
        payments.forEach(payment => {
          if (payment.utr_number && payment.utr_number.trim() !== '') {
            const utr = payment.utr_number.trim();
            if (utrMap[utr]) {
              if (!duplicates.includes(utr)) {
                duplicates.push(utr);
              }
            } else {
              utrMap[utr] = true;
            }
          }
        });
        setDuplicateUTRs(duplicates);

        // Detect duplicate phone + amount on same entry date
        const amountPhoneMap = {};
        const dupAmtPhone = [];
        payments.forEach(payment => {
          const phone = payment.phone_no;
          const amount = payment.amount;
          const entryDate = payment.payment_entry_date ? moment(payment.payment_entry_date).format('YYYY-MM-DD') : '';
          if (phone && amount && entryDate) {
            const key = `${phone}_${amount}_${entryDate}`;
            if (amountPhoneMap[key]) {
              if (!dupAmtPhone.includes(payment.payment_id)) dupAmtPhone.push(payment.payment_id);
              if (!dupAmtPhone.includes(amountPhoneMap[key])) dupAmtPhone.push(amountPhoneMap[key]);
            } else {
              amountPhoneMap[key] = payment.payment_id;
            }
          }
        });
        setDuplicateAmountPhone(dupAmtPhone);

        // Clear selected payments when data refreshes
        setSelectedPayments([]);
        setSelectedVerifyPayments([]);
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  async function handleDelete(id) {
    try {
      const response = await axios.delete(`${baseUrl}/payments/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Payment deleted successfully!',
          placement: 'topRight'
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Are you sure you want to delete this item?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleTableChange = (paginationInfo, _tableFilters, sorter) => {
    const { current, pageSize } = paginationInfo;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : order === 'descend' ? 'desc' : null;
    setSortField(field);
    setSortOrder(formattedOrder);
    // Fetch with current custom filters — do NOT overwrite with AntD column filters
    getPaymentList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleSearch = value => {
    setSearch(value);
    getPaymentList(currentPage, limit, sortField, sortOrder, value, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    getPaymentList(1, value, sortField, sortOrder, search, filters);
  };

  const debouncedgetPaymentList = useCallback(debounce((page, lim, sf, so, s, f) => {
    getPaymentList(page, lim, sf, so, s, f);
  }, 500), []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = (field, value, searchMode = false) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    sessionStorage.setItem('payment_list_filters', JSON.stringify(newFilters));
    if (field === 'bank_account') {
      getTodayTotal(value || null);
    }
    if (searchMode === true) {
      getPaymentList(1, limit, sortField, sortOrder, search, newFilters);
    } else if (searchMode === 'debounced') {
      debouncedgetPaymentList(1, limit, sortField, sortOrder, search, newFilters);
    }
  };

 

  const [showPaymentFilter, setshowPaymentFilter] = useState(true);
  const [showPermanentAddress, setShowPermanentAddress] = useState(false);
  const [showTemporaryAddress, setShowTemporaryAddress] = useState(false);

  const handleUserFilterCheckboxChange = (e) => {
    setshowPaymentFilter(e.target.checked);
    if (staffList?.length === 0) {
      getStaffList();
    }
  };



  //For show image on model larges
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const showModal = (image) => {
    setCurrentImage(image || userDummy);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleVerifyPayment = async (paymentId) => {
    Modal.confirm({
      title: 'Are you sure you want to verify this payment?',
      onOk: async () => {
        try {
          const response = await axios.patch(`${baseUrl}/payments/paymentStatusVerify/${paymentId}`, { payment_virify: 'verified' }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
            },
          });

          if (response.status === 200) {
            getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
            notification.success({
              message: 'Success',
              description: 'Payment verified successfully',
              placement: 'topRight',
              duration: 1.5
            });
          }
        } catch (error) {
          notification.info({
            message: 'Info',
            description: "Failed to verify payment",
            placement: 'topRight'
          });

        }
      },
    });
  }

  const setSendPaynmentMsg = async (paymentId,userId) => {
    Modal.confirm({
      title: 'Are you sure you want to send payment message?',
      onOk: async () => {
        try {
          const response = await axios.patch(`${baseUrl}/payments/paymentSendMsg/${paymentId}`, { userId: userId }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
            },
          });

          if (response.status === 200) {
            getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
            notification.success({
              message: 'Success',
              description: 'Payment message sent successfully',
              placement: 'topRight',
              duration: 1.5
            });
          }
        } catch (error) {
          notification.info({
            message: 'Info',
            description: "Failed to verify payment",
            placement: 'topRight'
          });

        }
      },
    });
  }

  const downloadPoster = async (paymentId, receiptNo) => {
    try {
      // Regenerate poster with current member data before downloading
      const res = await axios.get(`${baseUrl}/payments/regenerate-poster/${paymentId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
      const posterUrl = res.data?.poster_url || `${socketUrl}/uploads/payment_poster/payment_poster_${paymentId}.jpg`;
      const link = document.createElement('a');
      link.href = posterUrl;
      link.download = `poster_${receiptNo || paymentId}.jpg`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      // Fallback to cached poster if regeneration fails
      const posterUrl = `${socketUrl}/uploads/payment_poster/payment_poster_${paymentId}.jpg`;
      const link = document.createElement('a');
      link.href = posterUrl;
      link.download = `poster_${receiptNo || paymentId}.jpg`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  //For filter set
  const handleSearchReport = () => {
    // Trigger API call with current filters
    getPaymentList(1, limit, sortField, sortOrder, search, filters);
  };

  const handleResetFilters = () => {
    getTodayTotal(null); // reset stats to all accounts
    const resetFilters = {
      name: '',
      email: '',
      phone: '',
      amount: '',
      receipt_no: '',
      e_reciept_no: '',
      e_reciept_date: '',
      utr_number: '',
      bank_account: '',
      relation_hn: '',
      special_occassion_category: '',
      transaction_date: '',
      pyament_mode_type: '',
      payment_entry_date: '',
      payment_virify: '',
      is_send: '',
      staff_id: '',
      month_range: [],
      amountMin: '',
      amountMax: '',
      min_monthly_amount: '',
      max_monthly_amount: '',
      txn_date_range: [],
      entry_date_range: [],
      receipt_queue: '',
    };
    setFilters(resetFilters);
    sessionStorage.removeItem('payment_list_filters');
    setSearch('');
    setSortField(null);
    setSortOrder(null);
    getPaymentList(1, limit, null, null, '', resetFilters);
  };

  const handleCheckPayment = async (paymentId, check_type) => {



    try {
      const response = await axios.patch(`${baseUrl}/payments/paymentStatusVerify/${paymentId}`, { check_type: check_type }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
        },
      });

      if (response.status === 200) {
        getPaymentList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Payment update successfully',
          placement: 'topRight',
          duration: 2.0
        });
      }
    } catch (error) {
      notification.info({
        message: 'Info',
        description: "Failed to checked payment",
        placement: 'topRight'
      });

    }


  }

 const handleEdit = (id) => {
        setCurrentPaymentId(id);
        if (toggleEditDrawer) {
            toggleEditDrawer(true);
        }
    };

  const handleView = (id) => {
    setViewPaymentId(id);
    setViewDrawerVisible(true);
  };



  const exportToExcel = async () => {
    setLoading(true)
    const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
    const searchParam = search ? `&search=${search}` : '';
    const filterParams = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&');
    const response = await axios.get(`${baseUrl}/payments/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      }
    });
    if (response.data.status) {
      setLoading(false)
      const formattedData = response.data.result.map((user, index) => ({
        "Sr.No": index + 1,
        "Phone no": user.phone_no,
        "Name": user.name,
        "Relation": user.relation,
        "Father Name": user.father_name,
        "Village": user.per_village,
        "District ": user.per_district,
        "Receipt no": user.receipt_no,
        "Amount": parseFloat(user.amount) || 0,
        "Tnx (UTR/ID)": user.utr_number,
        "Tnx Date": user.transaction_date ? moment(user.transaction_date).format('DD-MM-YYYY') : '-',
        "Start Month": user.start_month ? moment(user.start_month).format('MM-YYYY') : '-',
        "End Month": user.end_month ? moment(user.end_month).format('MM-YYYY') : '-',
        "Duration": user.duration_type,
        "Monthly Share": parseFloat(user.announced_amount) || 0,
        "Account": user.bank_account,
        "Special Occassion": user.special_occassion_category,
        "Pay Entry Date": user.payment_entry_date ? moment(user.payment_entry_date).format('DD-MM-YYYY') : '-',
        "C/R-Reciept": user.e_reciept_no,
        "C/R-Date": user.e_reciept_date ? moment(user.e_reciept_date).format('DD-MM-YYYY') : '-',
        "Payment Status": user.payment_virify,
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      // Set column width for better readability
      const columnWidths = [
        { wch: 8 },  // Sr.No
        { wch: 15 }, // Phone no
        { wch: 20 }, // Name
        { wch: 15 }, // Relation
        { wch: 20 }, // Father Name
        { wch: 20 }, // Village
        { wch: 20 }, // District
        { wch: 15 }, // Receipt no
        { wch: 12 }, // Amount
        { wch: 20 }, // Tnx (UTR/ID)
        { wch: 15 }, // Tnx Date
        { wch: 12 }, // Start Month
        { wch: 12 }, // End Month
        { wch: 15 }, // Duration
        { wch: 15 }, // Monthly Share
        { wch: 20 }, // Account
        { wch: 20 }, // Special Occassion
        { wch: 15 }, // Pay Entry Date
        { wch: 15 }, // C/R-Reciept
        { wch: 15 }, // C/R-Date
        { wch: 15 }, // Payment Status
      ];
      worksheet['!cols'] = columnWidths;

      // Format Amount and Monthly Share columns as numbers with 2 decimal places
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        // Amount column (column I, index 8)
        const amountCell = XLSX.utils.encode_cell({ r: row, c: 8 });
        if (worksheet[amountCell]) {
          worksheet[amountCell].t = 'n'; // Set type to number
          worksheet[amountCell].z = '0.00'; // Set number format to 2 decimal places
        }

        // Monthly Share column (column O, index 14)
        const monthlyShareCell = XLSX.utils.encode_cell({ r: row, c: 14 });
        if (worksheet[monthlyShareCell]) {
          worksheet[monthlyShareCell].t = 'n'; // Set type to number
          worksheet[monthlyShareCell].z = '0.00'; // Set number format to 2 decimal places
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Payment History");
      XLSX.writeFile(workbook, "Payment-History.xlsx");
    } else {
      setLoading(false)
      notification.info({
        message: 'Info',
        description: response.data.message,
        placement: 'topRight'
      });
    }
  };

  // End of Day Report — account 1, today's entries
  const [dayReportLoading, setDayReportLoading] = useState(false);

  const exportDayReport = async () => {
    setDayReportLoading(true);
    try {
      const today = moment().format('YYYY-MM-DD');
      const todayFormatted = moment().format('DD-MM-YYYY');
      const response = await axios.get(
        `${baseUrl}/payments/list?page=1&limit=all${filters.bank_account ? `&bank_account=${filters.bank_account}` : ''}&payment_entry_date=${todayFormatted}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );
      if (!response.data.status) {
        notification.error({ message: 'Failed to fetch today\'s data', placement: 'topRight' });
        return;
      }
      const payments = response.data.result;
      if (payments.length === 0) {
        notification.info({ message: 'No entries found for today', placement: 'topRight' });
        return;
      }

      // ── Summary stats ─────────────────────────────────────────
      const totalAmount = payments.reduce((s, p) => s + (parseFloat(p.amount) || 0), 0);
      const verified = payments.filter(p => p.payment_virify === 'verified');
      const pending = payments.filter(p => p.payment_virify === 'pending');
      const failed = payments.filter(p => p.payment_virify === 'failed');
      const verifiedAmount = verified.reduce((s, p) => s + (parseFloat(p.amount) || 0), 0);
      const pendingAmount = pending.reduce((s, p) => s + (parseFloat(p.amount) || 0), 0);

      // ── Staff-wise breakdown ───────────────────────────────────
      const staffMap = {};
      payments.forEach(p => {
        const isMemberSelf = !p.staff_id && (p.pyament_mode_type || '').toLowerCase().includes('member-portal');
        const name = isMemberSelf ? 'Member (Self)' : ((p.firstName && p.lastName) ? `${p.firstName} ${p.lastName}` : (p.firstName || p.lastName || `Staff-${p.staff_id}` || 'Unknown'));
        if (!staffMap[name]) staffMap[name] = { count: 0, amount: 0, verified: 0, pending: 0 };
        staffMap[name].count += 1;
        staffMap[name].amount += parseFloat(p.amount) || 0;
        if (p.payment_virify === 'verified') staffMap[name].verified += 1;
        if (p.payment_virify === 'pending') staffMap[name].pending += 1;
      });

      // ── Payment mode breakdown ─────────────────────────────────
      const modeMap = {};
      payments.forEach(p => {
        const mode = p.pyament_mode_type || 'Unknown';
        if (!modeMap[mode]) modeMap[mode] = { count: 0, amount: 0 };
        modeMap[mode].count += 1;
        modeMap[mode].amount += parseFloat(p.amount) || 0;
      });

      const wb = XLSX.utils.book_new();

      // Sheet 1 — Summary
      const summaryData = [
        ['END OF DAY REPORT — SHIKSHA NIDHI (Account 1)', ''],
        ['Date', moment().format('DD MMMM YYYY')],
        ['', ''],
        ['OVERVIEW', ''],
        ['Total Entries', payments.length],
        ['Total Amount (₹)', totalAmount.toFixed(2)],
        ['Verified Entries', verified.length],
        ['Verified Amount (₹)', verifiedAmount.toFixed(2)],
        ['Pending Entries', pending.length],
        ['Pending Amount (₹)', pendingAmount.toFixed(2)],
        ['Failed Entries', failed.length],
        ['Messages Sent', payments.filter(p => p.is_send === 'sent').length],
        ['', ''],
        ['STAFF-WISE BREAKDOWN', ''],
        ['Staff', 'Entries', 'Amount (₹)', 'Verified', 'Pending'],
        ...Object.entries(staffMap).map(([name, d]) => [name, d.count, d.amount.toFixed(2), d.verified, d.pending]),
        ['', ''],
        ['PAYMENT MODE BREAKDOWN', ''],
        ['Mode', 'Entries', 'Amount (₹)'],
        ...Object.entries(modeMap).map(([mode, d]) => [mode, d.count, d.amount.toFixed(2)]),
      ];
      const summaryWs = XLSX.utils.aoa_to_sheet(summaryData);
      summaryWs['!cols'] = [{ wch: 30 }, { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 12 }];
      XLSX.utils.book_append_sheet(wb, summaryWs, 'Summary');

      // Sheet 2 — Detail
      const detailData = payments.map((p, i) => ({
        'Sr.No': i + 1,
        'Receipt No': p.receipt_no,
        'Name': p.name,
        'Phone': p.phone_no,
        'Amount (₹)': parseFloat(p.amount) || 0,
        'UTR/ID': p.utr_number,
        'Pay Mode': p.pyament_mode_type,
        'Status': p.payment_virify,
        'Msg Sent': p.is_send === 'sent' ? 'Yes' : 'No',
        'Staff': (p.firstName && p.lastName) ? `${p.firstName} ${p.lastName}` : (p.firstName || p.lastName || `Staff-${p.staff_id}` || '-'),
        'Entry Time': p.payment_entry_date ? moment(p.payment_entry_date).format('DD-MM-YYYY') : '-',
      }));
      const detailWs = XLSX.utils.json_to_sheet(detailData);
      detailWs['!cols'] = [
        { wch: 6 }, { wch: 12 }, { wch: 22 }, { wch: 14 }, { wch: 12 },
        { wch: 22 }, { wch: 16 }, { wch: 10 }, { wch: 10 }, { wch: 18 }, { wch: 14 },
      ];
      XLSX.utils.book_append_sheet(wb, detailWs, 'Detail');

      XLSX.writeFile(wb, `Day-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
      notification.success({ message: 'Day Report downloaded', placement: 'topRight', duration: 2 });
    } catch (err) {
      notification.error({ message: 'Failed to generate report', placement: 'topRight' });
    } finally {
      setDayReportLoading(false);
    }
  };

  const rowClassName = (record) => {
    return record.is_payment_check === 'checked' ? 'checked-payment-row' : 'checked-row';
  };

  const getPanelValue = async (searchText, columnName, tableName) => {
    if (searchText.length < 3) {
      setOptionSuggestion([]);
      return;
    }

    try {
      const response = await axios.get(`${baseUrl}/payments/getSuggestionValue/`, {
        params: { q: searchText, column: columnName, table: tableName },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        setOptionSuggestion(response.data.result);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const tableData = useMemo(() => paymentList.map((payment, index) => ({
    key: (limit * (currentPage - 1)) + index + 1,
    payment_id: payment.payment_id,
    payment_status: payment.payment_virify === 1 ? 'Verified' : payment.payment_virify === 2 ? 'Failed' : 'Pending',
    user_id: payment.user_id,
    is_virify: payment.payment_virify,
    is_reciept_status: payment.reciept_status,
    is_send_msg: payment.is_send,
    comment: payment.comment || '',
    razorpay_fee: payment.razorpay_fee || null,
    razorpay_gst: payment.razorpay_gst || null,
    net_amount: payment.net_amount || null,
    account_id: payment.account_id,
    is_payment_check: payment.is_payment_check,
    receipt_queue: payment.receipt_queue,
    name: (
      <>
        <Avatar.Group style={{ display: 'block', width: '100%' }}>
          <div className="avatar-info" style={{ position: 'relative', paddingBottom: 14, width: '100%' }}>
            <Title level={5}>
              <Link to={`/users/view/${payment.user_id}`}>
                {payment.name}
              </Link>
            </Title>
              <p style={{ cursor: 'pointer', color: '#595959', margin: 0, marginTop: 3, fontSize: '14px', fontWeight: 500 }}
                onClick={() => copyToClipboard(payment.phone_no, 'Phone')}>
                {payment.phone_no}
              </p>
            {payment.payment_commitment === 'one_time' ? (
              <span style={{ position: 'absolute', bottom: -2, right: 0, fontSize: '10px', color: '#52c41a', fontWeight: 700 }}>
                One-Time
              </span>
            ) : payment.announced_amount ? (
              <span style={{ position: 'absolute', bottom: -2, right: 0, fontSize: '10px', color: '#faad14', fontWeight: 700 }}>
                Rs.{parseFloat(payment.announced_amount).toFixed(2)}
              </span>
            ) : null}
          </div>
        </Avatar.Group>{" "}
      </>
    ),
    receipt_no: (
      <>
        <div className="author-info">
          <Title level={5}>
            {payment?.receipt_no ? payment?.receipt_no : '-'}
          </Title>
        </div>
      </>
    ),
    amount: (
      <div className="author-info">
        <Title level={5} style={{ margin: 0 }}>Rs.{payment.amount}</Title>
        {payment.razorpay_fee > 0 && (
          <div style={{ fontSize: 10, color: '#f5222d', lineHeight: 1.5 }}>
            RZP: -₹{parseFloat(payment.razorpay_fee).toFixed(2)}
          </div>
        )}
        {payment.razorpay_gst > 0 && (
          <div style={{ fontSize: 10, color: '#fa8c16', lineHeight: 1.5 }}>
            GST: -₹{parseFloat(payment.razorpay_gst).toFixed(2)}
          </div>
        )}
        {payment.net_amount > 0 && (
          <div style={{ fontSize: 10, color: '#52c41a', lineHeight: 1.5, fontWeight: 600 }}>
            Net: ₹{parseFloat(payment.net_amount).toFixed(2)}
          </div>
        )}
      </div>
    ),
    utr_number: payment.utr_number ? (
      <div className="author-info" style={{ cursor: 'pointer' }}
        onClick={() => copyToClipboard(payment.utr_number, 'UTR')}>
        <Title level={5} style={{ color: '#1890ff', margin: 0, fontSize: '14px' }}>
          {payment.utr_number}
        </Title>
      </div>
    ) : <span style={{ color: '#ccc' }}>-</span>,
    transaction_date: (
      <>
        <div className="author-info">
          <Title level={5}>{payment.transaction_date ? moment(payment.transaction_date).format('DD MMMM YYYY') : '-'}</Title>
        </div>
      </>
    ),
    start_month: (
      <>
        <div className="author-info">
          <Title level={5}>{payment.start_month ? moment(payment.start_month).format('MMMM YYYY') : '-'}</Title>
        </div>
      </>
    ),
    end_month: (
      <>
        <div className="author-info">
          <Title level={5}>{payment.end_month ? moment(payment.end_month).format('MMMM YYYY') : '-'}</Title>
        </div>
      </>
    ),
    duration_type: (
      <>
        <div className="author-info">
          <Title level={5}> {payment.duration_type}</Title>
        </div>
      </>
    ),
    announced_amount: (
      <>
        <div className="author-info">
          <Title level={5}> Rs.{payment.announced_amount}</Title>
        </div>
      </>
    ),
    bank_account: (
      <>
        <div className="author-info">
          <Title level={5}> {payment.bank_account}</Title>
        </div>
      </>
    ),
    special_occassion_category: (
      <>
        <div className="author-info">
          <Title level={5}> {payment.special_occassion_category}</Title>
        </div>
      </>
    ),
    payment_entry_date: (
      <>
        <div className="author-info">
          <Title level={5}>{payment.payment_entry_date ? moment(payment.payment_entry_date).format('DD MMMM YYYY') : '-'}</Title>
        </div>
      </>
    ),
    e_reciept_no: (
      <>
        <div className="author-info">
          <Title level={5}> {payment.e_reciept_no}</Title>
        </div>
      </>
    ),
    e_reciept_date: (
      <>
        <div className="author-info">
          <Title level={5}>{payment.e_reciept_date ? moment(payment.e_reciept_date).format('DD MMMM YYYY') : '-'}</Title>
        </div>
      </>
    ),
    firstName: (
      <>
        <div className="author-info">
          <Title level={5}> {payment.firstName}  {payment.lastName}</Title>
          <span style={{ fontSize: '10px', color: '#888' }}>
            ({moment(payment.createdAt).format('hh:mm A')})
          </span>
        </div>
      </>
    ),
    firstNameUpdate: (
      <>
        <div className="author-info">
          <Title level={5}> {payment.firstNameUpdate}  {payment.lastNameUpdate}</Title>
          <span style={{ fontSize: '10px', color: '#888' }}>
            ({moment(payment.updatedAt).format('hh:mm A')})
          </span>
        </div>
      </>
    ),
    is_payment_check: payment.is_payment_check,
    payment_virify: (
      <div className="button-container" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {(payment.payment_virify === 'pending' || payment.payment_virify === 'failed') && (
          <Button
            type="primary"
            style={{
              backgroundColor: payment.payment_virify === 'pending' ? '#722ed1' : '#ff4d4f',
              color: '#fff',
              borderColor: payment.payment_virify === 'pending' ? '#722ed1' : '#ff4d4f',
              fontSize: "12px",
              height: "35px",
              padding: "0 8px",
              lineHeight: "35px",
              fontWeight: 'bold',
              boxShadow: payment.payment_virify === 'pending' ? '0 2px 4px rgba(250, 173, 20, 0.3)' : '0 2px 4px rgba(255, 77, 79, 0.3)'
            }}
            onClick={() => handleVerifyPayment(payment.payment_id)}
          >
            {payment.payment_virify === 'pending' ? 'Pending' : 'Failed'}
          </Button>
        )}
        {payment.payment_virify === 'verified' && (
          <Button
            type="primary"
            style={{
              backgroundColor: '#52c41a',
              color: '#fff',
              borderColor: '#52c41a',
              fontSize: "12px",
              height: "35px",
              padding: "0 8px",
              lineHeight: "35px",
              fontWeight: 'bold',
              boxShadow: '0 2px 4px rgba(82, 196, 26, 0.3)'
            }}
            disabled
          >
            Verified
          </Button>
        )}
        {payment.payment_virify === 'pending' && payment.payment_entry_date && (() => {
          const days = moment().diff(moment(payment.payment_entry_date), 'days');
          if (days <= 0) return null;
          return (
            <span style={{
              display: 'inline-block',
              fontSize: '10px',
              fontWeight: 700,
              padding: '1px 5px',
              borderRadius: 8,
              background: days > 3 ? '#fff1f0' : '#fffbe6',
              border: `1px solid ${days > 3 ? '#ffa39e' : '#ffe58f'}`,
              color: days > 3 ? '#cf1322' : '#d48806',
            }}>
              {days}d old
            </span>
          );
        })()}
        {duplicateUTRs.includes(payment.utr_number) && (
          <div style={{
            fontSize: '10px',
            color: '#ff4d4f',
            fontWeight: 'bold',
            backgroundColor: '#fff2f0',
            padding: '2px 4px',
            borderRadius: '3px',
            border: '1px solid #ffccc7',
            textAlign: 'center'
          }}>
            ⚠ Duplicate UTR
          </div>
        )}
        {duplicateAmountPhone.includes(payment.payment_id) && (
          <div style={{
            fontSize: '10px',
            color: '#d46b08',
            fontWeight: 'bold',
            backgroundColor: '#fff7e6',
            padding: '2px 4px',
            borderRadius: '3px',
            border: '1px solid #ffd591',
            textAlign: 'center'
          }}>
            ⚠ Dup Amount+Phone
          </div>
        )}
      </div>
    ),
    action: (
      <div className="button-container">
        {hasPermission('/payments', 'editPermission') && (
          <button onClick={() => handleEdit(payment.payment_id)} className="update-btn">
            <EditOutlined />
          </button>
        )}
        {hasPermission('/payments', 'readPermission') && (
          <Link onClick={() => handleView(payment.payment_id)} className="update-btn">
            <EyeOutlined />
          </Link>
        )}
        {hasPermission('/payments', 'deletePermission') && (
          <button onClick={() => showDeleteConfirm(payment.payment_id)} className="delete-btn">
            <DeleteOutlined />
          </button>
        )}
      </div>
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  })), [paymentList, duplicateUTRs, duplicateAmountPhone, currentPage, limit]);


  return (

    <>

      {loading && (
        <div className="full-page-loader">
          <Spin size="large" />
        </div>
      )}
      
      {/* Bulk Send Progress Modal */}
      {bulkSendLoading && (
        <Modal
          title="Sending WhatsApp Receipts"
          open={bulkSendLoading}
          footer={null}
          closable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Spin size="large" />
            <div style={{ marginTop: '16px' }}>
              <p>Sending WhatsApp receipts... Please wait</p>
              <p><strong>{bulkSendProgress.current + 1}</strong> of <strong>{bulkSendProgress.total}</strong> in progress</p>
              <div style={{ 
                width: '100%', 
                height: '10px', 
                backgroundColor: '#f0f0f0', 
                borderRadius: '5px',
                marginTop: '10px'
              }}>
                <div style={{
                  width: `${((bulkSendProgress.current + 1) / bulkSendProgress.total) * 100}%`,
                  height: '100%',
                  backgroundColor: '#52c41a',
                  borderRadius: '5px',
                  transition: 'width 0.3s ease'
                }}></div>
              </div>
              <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                Each receipt is being sent through your existing WhatsApp system
              </p>
            </div>
          </div>
        </Modal>
      )}

      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Payment History</span>}
              headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
              extra={
                <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
                  {(() => {
                    const btnStyle = {
                      background: 'rgba(255,255,255,0.15)',
                      borderColor: 'rgba(255,255,255,0.35)',
                      color: '#fff',
                      fontWeight: 600,
                      fontSize: 12,
                      height: 28,
                      padding: '0 10px',
                      lineHeight: '26px',
                    };
                    return (
                      <>
                        {hasPermission('/payments/add_user_payment', 'createPermission') && (
                          <Tooltip title="Add New Payment">
                            <Link to="/payments/add_user_payment" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, height: 28, padding: '0 10px', fontSize: 12, borderRadius: 5, background: 'rgba(255,255,255,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.35)', fontWeight: 600, textDecoration: 'none' }}>
                              <PlusCircleOutlined /> Add Payment
                            </Link>
                          </Tooltip>
                        )}
                        {hasPermission('/payments', 'downloadPermission') && (
                          <Tooltip title="Download Excel Report">
                            <Button icon={<FileExcelOutlined />} onClick={exportToExcel} style={btnStyle}>Excel</Button>
                          </Tooltip>
                        )}
                        {hasPermission('/payments', 'editPermission') && (
                          <Tooltip title="Reconcile Statement">
                            <Button icon={<BankOutlined />} onClick={() => setReconcileVisible(true)} style={btnStyle}>Reconcile</Button>
                          </Tooltip>
                        )}
                        {hasPermission('/payments', 'editPermission') && (
                          <Tooltip title={bulkVerifyMode ? 'Turn Off Bulk Verify Mode' : 'Turn On Bulk Verify Mode'}>
                            <Button
                              icon={<CheckCircleOutlined />}
                              onClick={() => { setBulkVerifyMode(v => !v); setSelectedVerifyPayments([]); }}
                              style={{
                                ...btnStyle,
                                background: bulkVerifyMode ? '#52c41a' : 'rgba(255,255,255,0.15)',
                                borderColor: bulkVerifyMode ? '#52c41a' : 'rgba(255,255,255,0.35)',
                                boxShadow: bulkVerifyMode ? '0 0 0 2px rgba(82,196,26,0.4)' : 'none',
                              }}
                            >
                              {bulkVerifyMode ? 'Verify ON' : 'Bulk Verify'}
                            </Button>
                          </Tooltip>
                        )}
                        {hasPermission('/payments', 'downloadPermission') && (
                          <Tooltip title="Download Day Report">
                            <Button icon={<FileExcelOutlined />} loading={dayReportLoading} onClick={exportDayReport} style={btnStyle}>Day Report</Button>
                          </Tooltip>
                        )}
                        {hasPermission('/trash-payments', 'readPermission') && (
                          <Tooltip title="View Trash Payments">
                            <Link to="/trash-payments">
                              <Button icon={<DeleteOutlined />} style={btnStyle}>Trash</Button>
                            </Link>
                          </Tooltip>
                        )}
                        <Tooltip title="Receipt Template">
                          <Link to="/receipt-template">
                            <Button icon={<FileTextOutlined />} style={btnStyle}>Receipt</Button>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Daily Poster">
                          <Link to="/daily-poster">
                            <Button icon={<PictureOutlined />} style={btnStyle}>Poster</Button>
                          </Link>
                        </Tooltip>
                      </>
                    );
                  })()}
                </div>
              }
            >
              <div className="table-responsive payment-table">
                <Table
                  columns={columns}
                  rowClassName={rowClassName}
                  // pagination={false}

                  scroll={{ x: 'max-content' }}
                  bordered

                  title={() => (
                      <div style={{ marginBottom: '12px' }}>

                        {/* ── Today's Stats Cards ───────────────────────────── */}
                        <Row gutter={[10, 10]} style={{ marginBottom: 12 }}>
                          {[
                            { label: "Today's Total", value: `₹${dashboardStats.todayTotal.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`, color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff', icon: <RiseOutlined /> },
                            { label: 'Total Entry Today', value: dashboardStats.todayEntryCount, color: '#0958d9', bg: '#e8f0fe', border: '#93c5fd', icon: <CalendarOutlined /> },
                            { label: 'Verified', value: dashboardStats.todayVerified, color: '#389e0d', bg: '#f6ffed', border: '#b7eb8f', icon: <CheckCircleOutlined /> },
                            { label: 'Pending', value: dashboardStats.todayPending, color: '#d48806', bg: '#fffbe6', border: '#ffe58f', icon: <ClockCircleOutlined /> },
                            { label: 'Failed', value: dashboardStats.todayFailed, color: '#cf1322', bg: '#fff1f0', border: '#ffa39e', icon: <CloseCircleOutlined /> },
                            { label: 'Msgs Sent', value: dashboardStats.messagesSent, color: '#531dab', bg: '#f9f0ff', border: '#d3adf7', icon: <SendOutlined /> },
                            { label: 'Pending Receipts', value: dashboardStats.pendingReceipts, color: '#c41d7f', bg: '#fff0f6', border: '#ffadd2', icon: <FileExcelOutlined /> },
                          ].map(stat => (
                            <Col key={stat.label} xs={12} sm={8} md={3}>
                              <div style={{ background: stat.bg, border: `1px solid ${stat.border}`, borderRadius: 8, padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <span style={{ fontSize: 11, color: '#666', display: 'flex', alignItems: 'center', gap: 4 }}>
                                  <span style={{ color: stat.color }}>{stat.icon}</span> {stat.label}
                                </span>
                                <span style={{ fontSize: 18, fontWeight: 700, color: stat.color, lineHeight: 1.2 }}>{stat.value}</span>
                              </div>
                            </Col>
                          ))}
                          {/* Filtered Total card */}
                          <Col xs={12} sm={8} md={3}>
                            <div style={{ background: '#f0f5ff', border: '1px solid #adc6ff', borderRadius: 8, padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 2 }}>
                              <span style={{ fontSize: 11, color: '#666', display: 'flex', alignItems: 'center', gap: 4 }}>
                                <span style={{ color: '#2f54eb' }}><FilterOutlined /></span> Filter Total ({pagination.total})
                              </span>
                              <span style={{ fontSize: 18, fontWeight: 700, color: '#2f54eb', lineHeight: 1.2 }}>
                                ₹{filteredTotal.toLocaleString('en-IN', { maximumFractionDigits: 0 })}
                              </span>
                            </div>
                          </Col>
                        </Row>

                        {/* Filter Toggle Header */}
                        <div style={{ 
                          background: '#fafafa',
                          padding: '8px 12px',
                          borderRadius: '4px',
                          border: '1px solid #e8e8e8',
                          marginBottom: '8px'
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FilterOutlined style={{ marginRight: '6px', color: '#1890ff' }} />
                                <Checkbox 
                                  checked={showPaymentFilter}
                                  onChange={handleUserFilterCheckboxChange}
                                >
                                  <Title style={{ fontSize: 13, margin: 0 }} level={5}>Payment Filter</Title>
                                </Checkbox>
                              </div>
                              
                              {Object.values(filters).filter(val => val && val !== '' && (!Array.isArray(val) || val.length > 0)).length > 0 && (
                                <span style={{
                                  background: '#ff4d4f',
                                  color: 'white',
                                  borderRadius: '10px',
                                  padding: '2px 6px',
                                  fontSize: '10px',
                                  fontWeight: 'bold'
                                }}>
                                  {Object.values(filters).filter(val => val && val !== '' && (!Array.isArray(val) || val.length > 0)).length}
                                </span>
                              )}
                            </div>
                            
                            {/* Quick Action Buttons */}
                            <div style={{ display: 'flex', gap: '6px' }}>
                              <Button
                                size="small"
                                type={filters.payment_entry_date === moment().format('DD-MM-YYYY') ? 'primary' : 'text'}
                                icon={<CalendarOutlined />}
                                style={{ fontSize: '11px', padding: '2px 8px' }}
                                onClick={handleTodayFilter}
                              >
                                Today
                              </Button>
                              <Button
                                size="small"
                                type={filters.entry_date_range && filters.entry_date_range[0] === moment().startOf('isoWeek').format('DD-MM-YYYY') ? 'primary' : 'text'}
                                style={{ fontSize: '11px', padding: '2px 8px' }}
                                onClick={handleThisWeekFilter}
                              >
                                This Week
                              </Button>
                              <Button
                                size="small"
                                type={filters.entry_date_range && filters.entry_date_range[0] === moment().startOf('month').format('DD-MM-YYYY') ? 'primary' : 'text'}
                                style={{ fontSize: '11px', padding: '2px 8px' }}
                                onClick={handleThisMonthFilter}
                              >
                                This Month
                              </Button>
                              <Button size="small" type="text" style={{ fontSize: '11px', padding: '2px 8px' }}
                                onClick={() => handleFilterChange('payment_virify', filters.payment_virify === 'verified' ? '' : 'verified', true)}>
                                {filters.payment_virify === 'verified' ? '✓ Verified' : 'Verified'}
                              </Button>
                              <Button size="small" type="text" style={{ fontSize: '11px', padding: '2px 8px' }}
                                onClick={() => handleFilterChange('payment_virify', filters.payment_virify === 'pending' ? '' : 'pending', true)}>
                                {filters.payment_virify === 'pending' ? '⏳ Pending' : 'Pending'}
                              </Button>
                              <Button size="small" type="text" style={{ fontSize: '11px', padding: '2px 8px' }}
                                onClick={() => handleFilterChange('is_send', filters.is_send === '1' ? '' : '1', true)}>
                                {filters.is_send === '1' ? '📱 Sent' : 'Messages'}
                              </Button>

                              {/* Stage Selected button — visible when rows are selected */}
                              {selectedPayments.length > 0 && (
                                <Button
                                  size="small"
                                  type="primary"
                                  style={{ fontSize: '11px', padding: '2px 8px', background: '#fa8c16', borderColor: '#fa8c16' }}
                                  loading={stagingLoading}
                                  onClick={handleStageSelected}
                                >
                                  Stage ({selectedPayments.length})
                                </Button>
                              )}

                              {/* Queue filter toggle — shows count badge */}
                              <Badge count={queueCount} size="small" offset={[-2, 2]}>
                                <Button
                                  size="small"
                                  type={filters.receipt_queue === 'queued' ? 'primary' : 'text'}
                                  style={{ fontSize: '11px', padding: '2px 8px' }}
                                  onClick={handleViewQueue}
                                >
                                  📬 Queue
                                </Button>
                              </Badge>

                              {/* Send All Queued — visible when viewing the queue */}
                              {filters.receipt_queue === 'queued' && queueCount > 0 && (
                                <Button
                                  size="small"
                                  type="primary"
                                  style={{ fontSize: '11px', padding: '2px 8px' }}
                                  loading={stagingLoading}
                                  onClick={handleSendAllQueued}
                                >
                                  Send All ({queueCount})
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>

                        {showPaymentFilter && (
                          <div style={{ background: '#fff', padding: '10px 12px', borderRadius: '4px', border: '1px solid #e8e8e8', marginBottom: '8px' }}>

                            {/* ── Main Filters (always visible) ── */}
                            <Row gutter={[10, 10]} align="bottom">

                              {/* Phone */}
                              <Col xs={24} sm={12} md={6} lg={4}>
                                <label style={labelStyle}>Phone Number</label>
                                <Input
                                  value={filters.phone}
                                  onChange={e => handleFilterChange('phone', e.target.value, 'debounced')}
                                  placeholder="Phone number"
                                  style={{ width: '100%' }}
                                  allowClear
                                />
                              </Col>

                              {/* UTR */}
                              <Col xs={24} sm={12} md={6} lg={4}>
                                <label style={labelStyle}>UTR / Transaction ID</label>
                                <AutoComplete
                                  value={filters.utr_number}
                                  placeholder="Enter UTR/Tnx"
                                  options={optionSuggestion}
                                  onChange={(value) => {
                                    const sanitizedValue = value.replace(/\s+/g, '');
                                    handleFilterChange("utr_number", sanitizedValue, 'debounced');
                                  }}
                                  onSearch={(text) => getPanelValue(text.replace(/\s+/g, ''), "utr_number", "sn_payments")}
                                  style={{ width: '100%' }}
                                />
                              </Col>

                              {/* Transaction Date (single) */}
                              <Col xs={24} sm={12} md={6} lg={3}>
                                <label style={labelStyle}>Txn Date</label>
                                <DatePicker
                                  className="filter_dob"
                                  format="DD-MM-YYYY"
                                  value={filters.transaction_date ? moment(filters.transaction_date, 'DD-MM-YYYY') : null}
                                  onChange={(date, dateString) => handleFilterChange('transaction_date', dateString, true)}
                                  placeholder="Txn Date"
                                  style={{ width: '100%' }}
                                />
                              </Col>

                              {/* Bank Account */}
                              <Col xs={24} sm={12} md={6} lg={4}>
                                <label style={labelStyle}>Bank Account</label>
                                <Select
                                  style={{ width: '100%' }}
                                  placeholder="Select account"
                                  value={filters.bank_account || undefined}
                                  onChange={value => handleFilterChange('bank_account', value, true)}
                                  allowClear
                                >
                                  {bankAccounts.map(acc => (
                                    <Option key={acc.id} value={String(acc.id)}>{acc.account_name}</Option>
                                  ))}
                                </Select>
                              </Col>

                              {/* Payment Mode */}
                              <Col xs={24} sm={12} md={6} lg={3}>
                                <label style={labelStyle}>Payment Mode</label>
                                <Select
                                  style={{ width: '100%' }}
                                  placeholder="Mode"
                                  value={filters.pyament_mode_type || undefined}
                                  onChange={value => handleFilterChange('pyament_mode_type', value, true)}
                                  allowClear
                                >
                                  <Option value="UPI">UPI</Option>
                                  <Option value="Cash">Cash</Option>
                                  <Option value="Cheque">Cheque</Option>
                                  <Option value="RTGS-NEFT">RTGS/NEFT</Option>
                                  <Option value="Website-Razorpay">Website-Razorpay</Option>
                                  <Option value="Application-Razorpay">Application-Razorpay</Option>
                                  <Option value="Member-Portal-Razorpay">Member Portal-Rozapay</Option>
                                </Select>
                              </Col>

                              {/* Payment Status */}
                              <Col xs={24} sm={12} md={6} lg={3}>
                                <label style={labelStyle}>Payment Status</label>
                                <Select
                                  style={{ width: '100%' }}
                                  placeholder="Status"
                                  value={filters.payment_virify || undefined}
                                  onChange={value => handleFilterChange('payment_virify', value, true)}
                                  allowClear
                                >
                                  <Option value="pending">Pending</Option>
                                  <Option value="verified">Verified</Option>
                                  <Option value="failed">Failed</Option>
                                </Select>
                              </Col>

                              {/* Entry Date */}
                              <Col xs={24} sm={12} md={6} lg={3}>
                                <label style={labelStyle}>Entry Date</label>
                                <DatePicker
                                  className="filter_dob"
                                  format="DD-MM-YYYY"
                                  value={filters.payment_entry_date ? moment(filters.payment_entry_date, 'DD-MM-YYYY') : null}
                                  onChange={(date, dateString) => handleFilterChange('payment_entry_date', dateString, true)}
                                  placeholder="Entry Date"
                                  style={{ width: '100%' }}
                                />
                              </Col>

                              {/* Buttons */}
                              <Col xs={24} sm={12} md={6} lg={3} style={{ display: 'flex', gap: 6, alignItems: 'flex-end' }}>
                                <Button
                                  icon={<SearchOutlined />}
                                  onClick={handleSearchReport}
                                  style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', fontWeight: 600, flex: 1 }}
                                >
                                  Search
                                </Button>
                                <Button onClick={handleResetFilters}>Reset</Button>
                              </Col>

                              {/* More Filters toggle */}
                              <Col xs={24} sm={12} md={6} lg={1} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <Button
                                  size="small"
                                  onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                                  style={{ background: showAdvancedFilters ? '#7a0000' : '#f0f3f7', borderColor: '#7a0000', color: showAdvancedFilters ? '#fff' : '#7a0000', fontWeight: 600, whiteSpace: 'nowrap' }}
                                >
                                  {showAdvancedFilters ? '▲ Less' : '▼ More'}
                                </Button>
                              </Col>

                            </Row>

                            {/* ── More Filters (hidden by default) ── */}
                            {showAdvancedFilters && (
                              <div style={{ marginTop: 10, background: '#f8f9fa', borderRadius: 6, border: '1px solid #e0e6ee', padding: '10px 12px' }}>
                                <div style={{ fontSize: 11, color: '#7a0000', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Additional Filters</div>
                                <Row gutter={[10, 10]}>

                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Name</label>
                                    <Input value={filters.name} onChange={e => handleFilterChange('name', e.target.value)} placeholder="Enter name" style={{ width: '100%' }} allowClear />
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Amount</label>
                                    <Input placeholder="Amount" value={filters.amount} onChange={e => handleFilterChange('amount', e.target.value)} style={{ width: '100%' }} allowClear />
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Receipt No.</label>
                                    <Input placeholder="Receipt no." value={filters.receipt_no} onChange={e => handleFilterChange('receipt_no', e.target.value)} style={{ width: '100%' }} allowClear />
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Message Status</label>
                                    <Select style={{ width: '100%' }} placeholder="Msg Status" value={filters.is_send || undefined} onChange={value => handleFilterChange('is_send', value, true)} allowClear>
                                      <Option value="0">Pending</Option>
                                      <Option value="1">Sent</Option>
                                    </Select>
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Payment Type</label>
                                    <Select style={{ width: '100%' }} placeholder="All Types" value={filters.payment_commitment || undefined} onChange={value => handleFilterChange('payment_commitment', value, true)} allowClear>
                                      <Option value="recurring">Monthly (Recurring)</Option>
                                      <Option value="one_time">One-Time</Option>
                                    </Select>
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>C/R-Receipt</label>
                                    <Input placeholder="C/R-Receipt" value={filters.e_reciept_no} onChange={e => handleFilterChange('e_reciept_no', e.target.value)} style={{ width: '100%' }} allowClear />
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>C/R-Date</label>
                                    <DatePicker className="filter_dob" format="DD-MM-YYYY" value={filters.e_reciept_date ? moment(filters.e_reciept_date, 'DD-MM-YYYY') : null} onChange={(date, dateString) => handleFilterChange('e_reciept_date', dateString, true)} placeholder="C/R-Date" style={{ width: '100%' }} />
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Email</label>
                                    <Input placeholder="Email" value={filters.email} onChange={e => handleFilterChange('email', e.target.value)} style={{ width: '100%' }} allowClear />
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Relation</label>
                                    <Select style={{ width: '100%' }} placeholder="Relation" value={filters.relation_hn || undefined} onChange={value => handleFilterChange('relation_hn', value, true)} allowClear>
                                      <Option value="सुपुत्र श्री">सुपुत्र श्री</Option>
                                      <Option value="सुपुत्री श्री">सुपुत्री श्री</Option>
                                      <Option value="पत्नी श्री">पत्नी श्री</Option>
                                      <Option value="गोद पुत्र श्री">गोद पुत्र श्री</Option>
                                      <Option value="शिष्य श्री">शिष्य श्री</Option>
                                    </Select>
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Special Occasion</label>
                                    <Select style={{ width: '100%' }} placeholder="Occasion" value={filters.special_occassion_category || undefined} onChange={value => handleFilterChange('special_occassion_category', value, true)} allowClear showSearch filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}>
                                      {specialOccasions.map(opt => (
                                        <Option key={opt.id} value={opt.category_name}>{opt.category_name}</Option>
                                      ))}
                                    </Select>
                                  </Col>

                                  <Col xs={24} sm={12} md={8} lg={6}>
                                    <label style={labelStyle}>Month Range (Start - End)</label>
                                    <RangePicker className="filter_dob" picker="month" format="MM-YYYY"
                                      value={Array.isArray(filters.month_range) && filters.month_range.length === 2 ? [moment(filters.month_range[0], 'MM-YYYY'), moment(filters.month_range[1], 'MM-YYYY')] : null}
                                      onChange={(dates) => { const r = dates ? dates.map(d => d.format('MM-YYYY')) : []; handleFilterChange('month_range', r, true); }}
                                      placeholder={['Start Month', 'End Month']} style={{ width: '100%' }}
                                    />
                                  </Col>

                                  <Col xs={24} sm={12} md={8} lg={6}>
                                    <label style={labelStyle}>Txn Date Range</label>
                                    <RangePicker className="filter_dob" format="DD-MM-YYYY"
                                      value={Array.isArray(filters.txn_date_range) && filters.txn_date_range.length === 2 ? [moment(filters.txn_date_range[0], 'DD-MM-YYYY'), moment(filters.txn_date_range[1], 'DD-MM-YYYY')] : null}
                                      onChange={(dates) => { const r = dates ? dates.map(d => d.format('DD-MM-YYYY')) : []; handleFilterChange('txn_date_range', r, true); }}
                                      placeholder={['Start Txn Date', 'End Txn Date']} style={{ width: '100%' }}
                                    />
                                  </Col>

                                  <Col xs={24} sm={12} md={8} lg={6}>
                                    <label style={labelStyle}>Entry Date Range</label>
                                    <RangePicker className="filter_dob" format="DD-MM-YYYY"
                                      value={Array.isArray(filters.entry_date_range) && filters.entry_date_range.length === 2 ? [moment(filters.entry_date_range[0], 'DD-MM-YYYY'), moment(filters.entry_date_range[1], 'DD-MM-YYYY')] : null}
                                      onChange={(dates) => { const r = dates ? dates.map(d => d.format('DD-MM-YYYY')) : []; handleFilterChange('entry_date_range', r, true); }}
                                      placeholder={['Start Entry Date', 'End Entry Date']} style={{ width: '100%' }}
                                    />
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Amount Range</label>
                                    <div style={{ display: 'flex', gap: 4 }}>
                                      <Input placeholder="Min" value={filters.amountMin} onChange={e => handleFilterChange('amountMin', e.target.value)} style={{ flex: 1 }} />
                                      <Input placeholder="Max" value={filters.amountMax} onChange={e => handleFilterChange('amountMax', e.target.value)} style={{ flex: 1 }} />
                                    </div>
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Monthly Share Range</label>
                                    <div style={{ display: 'flex', gap: 4 }}>
                                      <Input placeholder="Min" value={filters.min_monthly_amount} onChange={e => handleFilterChange('min_monthly_amount', e.target.value)} style={{ flex: 1 }} />
                                      <Input placeholder="Max" value={filters.max_monthly_amount} onChange={e => handleFilterChange('max_monthly_amount', e.target.value)} style={{ flex: 1 }} />
                                    </div>
                                  </Col>

                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Staff Member</label>
                                    <Select style={{ width: '100%' }} placeholder="Select Staff" value={filters.staff_id || undefined} onChange={value => handleFilterChange('staff_id', value, true)} allowClear>
                                      {staffList && staffList.map(item => <Option key={item.id} value={item.id}>{item.firstName} {item.lastName}</Option>)}
                                    </Select>
                                  </Col>

                                </Row>
                              </div>
                            )}

                          </div>
                        )}

                        {/* Records per page and bulk selection controls */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ marginRight: 20, fontSize: '13px' }}>Records per page:</span>
                            <Select value={limit} onChange={handleLimitChange}>
                              <Option value={20}>20</Option>
                              <Option value={40}>40</Option>
                              <Option value={60}>60</Option>
                              <Option value={80}>80</Option>
                              <Option value={100}>100</Option>
                              <Option value={150}>150</Option>
                              <Option value={200}>200</Option>
                              <Option value={250}>250</Option>
                              <Option value={300}>300</Option>
                              <Option value={400}>400</Option>
                              <Option value={500}>500</Option>
                              <Option value={600}>600</Option>
                            </Select>
                          </div>

                          {/* Bulk Selection Controls */}
                          <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '15px',
                            padding: '8px 12px',
                            backgroundColor: '#f0f8ff',
                            borderRadius: '6px',
                            border: '1px solid #d9e5f2'
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Checkbox
                                checked={eligiblePayments.length > 0 && selectedPayments.length === eligiblePayments.length}
                                indeterminate={selectedPayments.length > 0 && selectedPayments.length < eligiblePayments.length}
                                onChange={(e) => handleSelectAll(e.target.checked)}
                                style={{ 
                                  transform: 'scale(1.2)',
                                  marginRight: '8px'
                                }}
                              />
                              <span style={{ 
                                fontSize: '13px', 
                                fontWeight: 500,
                                color: '#2c3e50'
                              }}>
                                Select All Eligible
                              </span>
                            </div>
                            
                            <div style={{ 
                              fontSize: '12px', 
                              color: '#666',
                              backgroundColor: '#fff',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              border: '1px solid #ddd'
                            }}>
                              <strong>{eligiblePayments.length}</strong> eligible
                            </div>
                            
                            {selectedPayments.length > 0 && (
                              <div style={{ 
                                fontSize: '12px', 
                                color: '#1890ff', 
                                fontWeight: 600,
                                padding: '4px 10px',
                                backgroundColor: '#e6f7ff',
                                borderRadius: '12px',
                                border: '1px solid #91d5ff'
                              }}>
                                {selectedPayments.length} selected
                              </div>
                            )}
                          </div>
                      
                          {/* Bulk Send Receipt Button */}
                          {selectedPayments.length > 0 && (
                            <Button
                              type="primary"
                              icon={<SendOutlined />}
                              onClick={handleBulkSendReceipts}
                              size="large"
                              style={{
                                backgroundColor: '#52c41a',
                                borderColor: '#52c41a',
                                fontWeight: 600,
                                boxShadow: '0 2px 4px rgba(82, 196, 26, 0.3)',
                                borderRadius: '6px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                              }}
                            >
                              Send {selectedPayments.length} Receipt{selectedPayments.length > 1 ? 's' : ''}
                            </Button>
                          )}
                        </div>

                        {/* Bulk Verify Mode Bar */}
                        {bulkVerifyMode && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '10px 14px',
                            marginTop: '8px',
                            backgroundColor: '#fff7e6',
                            borderRadius: '6px',
                            border: '2px solid #fa8c16',
                            flexWrap: 'wrap'
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <Checkbox
                                checked={verifyEligiblePayments.length > 0 && selectedVerifyPayments.length === verifyEligiblePayments.length}
                                indeterminate={selectedVerifyPayments.length > 0 && selectedVerifyPayments.length < verifyEligiblePayments.length}
                                onChange={(e) => handleVerifySelectAll(e.target.checked)}
                                style={{ transform: 'scale(1.2)' }}
                              />
                              <span style={{ fontSize: '13px', fontWeight: 600, color: '#d46b08' }}>
                                Select All Checked + Pending
                              </span>
                            </div>

                            <div style={{ fontSize: '12px', color: '#666', backgroundColor: '#fff', padding: '4px 10px', borderRadius: '4px', border: '1px solid #ffd591' }}>
                              <strong>{verifyEligiblePayments.length}</strong> eligible to verify
                            </div>

                            {selectedVerifyPayments.length > 0 && (
                              <div style={{ fontSize: '12px', color: '#d46b08', fontWeight: 700, padding: '4px 12px', backgroundColor: '#fff7e6', borderRadius: '12px', border: '1px solid #fa8c16' }}>
                                {selectedVerifyPayments.length} selected
                              </div>
                            )}

                            {selectedVerifyPayments.length > 0 && (
                              <Button
                                type="primary"
                                icon={<CheckCircleOutlined />}
                                onClick={handleBulkVerify}
                                loading={bulkVerifyLoading}
                                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', fontWeight: 700, borderRadius: 6 }}
                              >
                                Verify {selectedVerifyPayments.length} Payment{selectedVerifyPayments.length > 1 ? 's' : ''}
                              </Button>
                            )}

                            <Button
                              size="small"
                              onClick={() => { setBulkVerifyMode(false); setSelectedVerifyPayments([]); }}
                              style={{ marginLeft: 'auto', color: '#ff4d4f', borderColor: '#ff4d4f', fontWeight: 600 }}
                            >
                              Exit Verify Mode
                            </Button>
                          </div>
                        )}
                      </div>
                    )}





                  dataSource={tableData}
                  pagination={{
                    ...pagination,
                    showTotal: total => `Total ${total} records`,
                    style: { marginRight: 20 }
                  }}
                  onChange={handleTableChange}
                  sticky={{ offsetHeader: 64 }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        <Modal
          open={isModalVisible}
          footer={null}
          onCancel={handleCancel}
        >
          <img
            src={currentImage}
            alt="Profile"
            style={{ width: '100%' }}
          />
        </Modal>

        {/* Invoice Modal */}
        {sendPaynmentNotice &&
          <Invoice paymentId={sendPaynmentNotice} btnShow={['whatsappSend']} resetFxn={handleResendBtn} />
        }

      </div>


            <Drawer
              width={window.innerWidth > 992 ? '55%' : '80%'}
              open={currentPaymentId !== null}
              onClose={closeEditDrawer}
              bodyStyle={{
                padding: 0,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
              }}
              closable={false}
              destroyOnClose
              maskClosable={false}
            >
              {currentPaymentId && (
                <div style={{ height: '100%', overflowY: 'auto' }}>
                  <PaymentsEditForm
                    id={currentPaymentId}
                    onSuccess={handleEditSuccess}
                    isDrawerMode={true}
                    onClose={closeEditDrawer}
                  />
                </div>
              )}
            </Drawer>

      <Drawer
        title="Payment Details"
        width={window.innerWidth > 992 ? '55%' : '90%'}
        open={viewDrawerVisible}
        onClose={() => { setViewDrawerVisible(false); setViewPaymentId(null); }}
        bodyStyle={{ padding: '16px', overflowY: 'auto' }}
        destroyOnClose
      >
        {viewPaymentId && (
          <ViewPayments paymentId={viewPaymentId} />
        )}
      </Drawer>

      <BankReconcile
        visible={reconcileVisible}
        onClose={() => setReconcileVisible(false)}
        refreshList={() => getPaymentList(currentPage, limit, sortField, sortOrder, search, filters)}
      />

    </>
  );
}


export default PaymentsList;